[
    {
        "key": "My Zenplan",
        "value": "My Zenplan"
    },
    {
        "key": "My Dashboard",
        "value": "My Dashboard"
    },
    {
        "key": "My Delegates",
        "value": "My Delegates"
    },
    {
        "key": "My Shared Plans",
        "value": "My Shared Plans"
    },
    {
        "key": "my plans",
        "value": "my plans"
    },
    {
        "key": "home",
        "value": "home"
    },
    {
        "key": "my assets",
        "value": "my assets"
    },
    {
        "key": "pensions",
        "value": "pensions"
    },
    {
        "key": "bank accounts",
        "value": "bank accounts"
    },
    {
        "key": "managed portfolio",
        "value": "managed portfolio"
    },
    {
        "key": "important contacts",
        "value": "important contacts"
    },
    {
        "key": "important documents",
        "value": "important documents"
    },
    {
        "key": "items of valye",
        "value": "items of value"
    },
    {
        "key": "property",
        "value": "property"
    },
    {
        "key": "listed shares",
        "value": "listed shares"
    },
    {
        "key": "trust",
        "value": "trust"
    },
    {
        "key": "unlisted shares",
        "value": "unlisted shares"
    },
    {
        "key": "investment funds",
        "value": "investment funds"
    },
    {
        "key": "money owed",
        "value": "money owed"
    },
    {
        "key": "my debts",
        "value": "my debts"
    },
    {
        "key": "my daily life",
        "value": "my daily life"
    },
    {
        "key": "my digital life",
        "value": "my digital life"
    },
    {
        "key": "my wishes",
        "value": "my wishes"
    },
    {
        "key": "Click on a box to add or update items in your plan",
        "value": "Click on a box to add or update items in your plan"
    },
    {
        "key": "Here is where you can build, simple to create picture",
        "value": "Here is where you can build, simple to create picture"
    },
    {
        "key": "Get a snap-shot view of your plan's status, telling you what to add and what to update",
        "value": "Get a snap-shot view of your plan's status, telling you what to add and what to update"
    },
    {
        "key": "Share your zen plan with those closests to you so they can view it today, or in the future",
        "value": "Share your zen plan with those closests to you so they can view it today, or in the future"
    },
    {
        "key": "Here you can view all the plans that others have chosen to share with you",
        "value": "Here you can view all the plans that others have chosen to share with you"
    }

]